/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-12 11:02:08
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-06-12 11:15:42
 * @FilePath: /zeelool-nextjs/src/app/(staitc)/student-discount/components/StudentBeansWidget.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { useEffect, useRef } from 'react';

export default function StudentBeansWidget() {
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 检查脚本是否已经加载
    if (document.getElementById('beansid-script')) {
      return;
    }

    // 创建并添加脚本
    const script = document.createElement('script');
    script.src = 'https://cdn.studentbeans.com/third-party/all.js';
    script.async = false;
    script.id = 'beansid-script';

    // 添加到 head 中
    document.head.appendChild(script);

    // 清理函数（可选）
    return () => {
      const existingScript = document.getElementById('beansid-script');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div>
      <div
        ref={boxRef}
        className="w-full text-[0px] mt-0 mx-auto"
        dangerouslySetInnerHTML={{
          __html: '<beansid-landing-page slug="zeelool" territory="us"></beansid-landing-page>',
        }}
      />
    </div>
  );
}
